/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _circle2, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _circle3, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _circle4, _circle5, _circle6, _circle7, _path149, _path150, _path151, _circle8, _circle9, _circle0, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _circle1, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _circle10, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _circle11, _circle12, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _circle13, _circle14, _path352, _path353, _path354, _path355, _path356, _path357, _circle15, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _circle16, _path383, _path384, _circle17, _path385, _circle18, _circle19, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398;
const DoubleInteger = /*#__PURE__*/React.forwardRef(function DoubleInteger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8Zm-6,3H8V8h3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21Zm-6,3H21V21h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DoubleInteger.propTypes = iconPropTypes;
}
const DownToBottom = /*#__PURE__*/React.forwardRef(function DownToBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H28V24H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DownToBottom.propTypes = iconPropTypes;
}
const Download = /*#__PURE__*/React.forwardRef(function Download({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
      d: "M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12z"
    })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
      d: "M13,12v2H3v-2H2v2l0,0c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1l0,0v-2H13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24v4H6V24H4v4H4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2h0V24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Download.propTypes = iconPropTypes;
}
const WatsonHealthDownloadStudy = /*#__PURE__*/React.forwardRef(function WatsonHealthDownloadStudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14H23V16H19z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9,18h6a3,3,0,0,1,3,3v2H16V21a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1v2H6V21A3,3,0,0,1,9,18Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a4,4,0,1,0-4,4A4,4,0,0,0,16,13Zm-2,0a2,2,0,1,1-2-2A2,2,0,0,1,14,13Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthDownloadStudy.propTypes = iconPropTypes;
}
const Downstream = /*#__PURE__*/React.forwardRef(function Downstream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m5,24c-1.6567,0-3,1.3433-3,3s1.3433,3,3,3,3-1.3433,3-3-1.3433-3-3-3Zm0,4c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m16,24c-1.6567,0-3,1.3433-3,3s1.3433,3,3,3,3-1.3433,3-3-1.3433-3-3-3Zm0,4c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-1.6567,0-3,1.3433-3,3s1.3433,3,3,3,3-1.3433,3-3-1.3433-3-3-3Zm0,4c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m29.586,17.5859l-1.5859,1.5859v-3.1719c0-3.5542-2.6646-6.4917-6.0999-6.9355.0623-.3457.0999-.7007.0999-1.0645,0-3.3135-2.6863-6-6-6s-6,2.6865-6,6c0,.3638.0376.7188.0999,1.0645-3.4353.4438-6.0999,3.3813-6.0999,6.9355v3.1714l-1.5859-1.5854-1.4141,1.4141,4,4,4-4-1.4141-1.4141-1.5859,1.5859v-3.1719c0-2.6953,2.1479-4.8848,4.8203-4.9819.8799,1.5063,2.3945,2.5918,4.1797,2.8921v5.2617l-1.5859-1.5859-1.4141,1.4141,4,4,4-4-1.4141-1.4141-1.5859,1.5859v-5.2617c1.7852-.3003,3.2998-1.3857,4.1797-2.8921,2.6724.0972,4.8203,2.2866,4.8203,4.9819v3.1714l-1.5859-1.5854-1.4141,1.4141,4,4,4-4-1.4141-1.4141Zm-13.5859-5.5859c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Downstream.propTypes = iconPropTypes;
}
const DragHorizontal = /*#__PURE__*/React.forwardRef(function DragHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DragHorizontal.propTypes = iconPropTypes;
}
const DragVertical = /*#__PURE__*/React.forwardRef(function DragVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DragVertical.propTypes = iconPropTypes;
}
const Draggable = /*#__PURE__*/React.forwardRef(function Draggable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H14V10H10z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H22V10H18z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H14V18H10z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H22V18H18z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H14V26H10z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H22V26H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Draggable.propTypes = iconPropTypes;
}
const Draw = /*#__PURE__*/React.forwardRef(function Draw({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Draw.propTypes = iconPropTypes;
}
const DrillBack = /*#__PURE__*/React.forwardRef(function DrillBack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22L7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DrillBack.propTypes = iconPropTypes;
}
const DrillDown = /*#__PURE__*/React.forwardRef(function DrillDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DrillDown.propTypes = iconPropTypes;
}
const DrillThrough = /*#__PURE__*/React.forwardRef(function DrillThrough({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12L4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10v6H10a6,6,0,1,0,6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DrillThrough.propTypes = iconPropTypes;
}
const Drink_01 = /*#__PURE__*/React.forwardRef(function Drink_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drink_01.propTypes = iconPropTypes;
}
const Drink_02 = /*#__PURE__*/React.forwardRef(function Drink_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drink_02.propTypes = iconPropTypes;
}
const DriverAnalysis = /*#__PURE__*/React.forwardRef(function DriverAnalysis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DriverAnalysis.propTypes = iconPropTypes;
}
const Drone = /*#__PURE__*/React.forwardRef(function Drone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12a5,5,0,1,1,5-5H10a3,3,0,1,0-3,3Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25,12V10a3,3,0,1,0-3-3H20a5,5,0,1,1,5,5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30A5,5,0,0,1,7,20v2a3,3,0,1,0,3,3h2A5.0055,5.0055,0,0,1,7,30Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a5.0055,5.0055,0,0,1-5-5h2a3,3,0,1,0,3-3V20a5,5,0,0,1,0,10Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drone.propTypes = iconPropTypes;
}
const DroneDelivery = /*#__PURE__*/React.forwardRef(function DroneDelivery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V22h8Zm-6-2h4V24H14Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DroneDelivery.propTypes = iconPropTypes;
}
const DroneFront = /*#__PURE__*/React.forwardRef(function DroneFront({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19V15H26v2H6V15H4v4h7v4.4116L7,25.6367V30H9V26.8125L12.26,25h7.481L23,26.8125V30h2V25.6367l-4-2.2251V19Zm-9,4H13V19h6Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11H10V13H0z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H32V13H22z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DroneFront.propTypes = iconPropTypes;
}
const DroneVideo = /*#__PURE__*/React.forwardRef(function DroneVideo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "21",
    r: "1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19V15H26v2H6V15H4v4h7v4.4116L7,25.6367V30H9V26.8125L12.26,25h7.481L23,26.8125V30h2V25.6367l-4-2.2251V19Zm-9,4H13V19h6Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11H10V13H0z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H32V13H22z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DroneVideo.propTypes = iconPropTypes;
}
const DropPhoto = /*#__PURE__*/React.forwardRef(function DropPhoto({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H11a2,2,0,0,1-2-2V18a2,2,0,0,1,2-2h3.2793l.5441-1.6324A2,2,0,0,1,16.7208,13h4.5584a2,2,0,0,1,1.8974,1.3676L23.7207,16H27a2,2,0,0,1,2,2v9A2,2,0,0,1,27,29ZM11,27H27V18H22.2792l-1-3H16.7207l-1,3H11Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DropPhoto.propTypes = iconPropTypes;
}
const DropPhotoFilled = /*#__PURE__*/React.forwardRef(function DropPhotoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "22",
    r: "2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
    "data-icon-path": "inner-path"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  DropPhotoFilled.propTypes = iconPropTypes;
}
const Drought = /*#__PURE__*/React.forwardRef(function Drought({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Drought.propTypes = iconPropTypes;
}
const Dvr = /*#__PURE__*/React.forwardRef(function Dvr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15V11a2,2,0,0,0-2-2H22V23h2V17h1.48l2.34,6H30l-2.33-6H28A2,2,0,0,0,30,15Zm-6-4h4v4H24Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M6,23H2V9H6a4,4,0,0,1,4,4v6A4,4,0,0,1,6,23ZM4,21H6a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Dvr.propTypes = iconPropTypes;
}
const Earth = /*#__PURE__*/React.forwardRef(function Earth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Earth.propTypes = iconPropTypes;
}
const EarthAmericas = /*#__PURE__*/React.forwardRef(function EarthAmericas({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthAmericas.propTypes = iconPropTypes;
}
const EarthAmericasFilled = /*#__PURE__*/React.forwardRef(function EarthAmericasFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthAmericasFilled.propTypes = iconPropTypes;
}
const EarthEuropeAfrica = /*#__PURE__*/React.forwardRef(function EarthEuropeAfrica({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthEuropeAfrica.propTypes = iconPropTypes;
}
const EarthEuropeAfricaFilled = /*#__PURE__*/React.forwardRef(function EarthEuropeAfricaFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthEuropeAfricaFilled.propTypes = iconPropTypes;
}
const EarthFilled = /*#__PURE__*/React.forwardRef(function EarthFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthFilled.propTypes = iconPropTypes;
}
const EarthSoutheastAsia = /*#__PURE__*/React.forwardRef(function EarthSoutheastAsia({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H17V26H14z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H19V24H17z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H19V20H17z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthSoutheastAsia.propTypes = iconPropTypes;
}
const EarthSoutheastAsiaFilled = /*#__PURE__*/React.forwardRef(function EarthSoutheastAsiaFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H19V24H17z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H19V20H17z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H17V26H14z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EarthSoutheastAsiaFilled.propTypes = iconPropTypes;
}
const Earthquake = /*#__PURE__*/React.forwardRef(function Earthquake({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Earthquake.propTypes = iconPropTypes;
}
const EdgeCluster = /*#__PURE__*/React.forwardRef(function EdgeCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,7Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,16,3Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,11,26Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7,11a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,11ZM7,7A1,1,0,1,0,8,8,1.001,1.001,0,0,0,7,7Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,21,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,21,26Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,11Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,25,7Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M4,21a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,4,21Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,4,17Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,28,21Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,28,17Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeCluster.propTypes = iconPropTypes;
}
const EdgeDevice = /*#__PURE__*/React.forwardRef(function EdgeDevice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H23V23H9z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M11,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,11,14Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,21,14Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeDevice.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26A10,10,0,0,0,16,6h0Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement_01 = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16A10,10,0,0,0,16,6V16Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement_01.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement_02 = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H22V26a2.002,2.002,0,0,1,2-2h2V22H22V20h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H24v2h4Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16A10,10,0,0,0,16,6V16Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement_02.propTypes = iconPropTypes;
}
const WatsonHealthEdgeEnhancement_03 = /*#__PURE__*/React.forwardRef(function WatsonHealthEdgeEnhancement_03({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H22v2h4v2H23v2h3v2H22v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,26,20Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16A10,10,0,0,0,16,6V16Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthEdgeEnhancement_03.propTypes = iconPropTypes;
}
const EdgeNode = /*#__PURE__*/React.forwardRef(function EdgeNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "21",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "17",
    r: "1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeNode.propTypes = iconPropTypes;
}
const EdgeNodeAlt = /*#__PURE__*/React.forwardRef(function EdgeNodeAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "8",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "24",
    r: "1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeNodeAlt.propTypes = iconPropTypes;
}
const EdgeService = /*#__PURE__*/React.forwardRef(function EdgeService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H9V21H7z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13V21H11z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V21H15z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H21V21H19z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11H25V21H23z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdgeService.propTypes = iconPropTypes;
}
const Edit = /*#__PURE__*/React.forwardRef(function Edit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4,9c0.8-0.8,0.8-2,0-2.8c0,0,0,0,0,0l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0c0,0,0,0,0,0l-15,15V24h6.4L25.4,9z M20.4,4L24,7.6 l-3,3L17.4,7L20.4,4z M6,22v-3.6l10-10l3.6,3.6l-10,10H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Edit.propTypes = iconPropTypes;
}
const EditOff = /*#__PURE__*/React.forwardRef(function EditOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6L3.4,2L2,3.4l10.1,10.1L4,21.6V28h6.4l8.1-8.1L28.6,30L30,28.6z M9.6,26H6v-3.6l7.5-7.5l3.6,3.6L9.6,26z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,6.2L29.4,6.2l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0l0,0l0,0l-8,8l1.4,1.4L20,8.4l3.6,3.6L20,15.6l1.4,1.4l8-8 C30.2,8.2,30.2,7,29.4,6.2L29.4,6.2z M25,10.6L21.4,7l3-3L28,7.6L25,10.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EditOff.propTypes = iconPropTypes;
}
const EdtLoop = /*#__PURE__*/React.forwardRef(function EdtLoop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EdtLoop.propTypes = iconPropTypes;
}
const Education = /*#__PURE__*/React.forwardRef(function Education({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27a5.0059,5.0059,0,0,0-5-5H13a5.0059,5.0059,0,0,0-5,5v3H6V27a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M5,6A1,1,0,0,0,4,7v9H6V7A1,1,0,0,0,5,6Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Education.propTypes = iconPropTypes;
}
const ElementPicker = /*#__PURE__*/React.forwardRef(function ElementPicker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18h4c1.1045,0,2-.8955,2-2v-4c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v1h-5v-5c0-1.6543-1.3457-3-3-3h-4v-1c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v4c0,1.1045.8955,2,2,2h4c1.1045,0,2-.8955,2-2v-1h4c.5515,0,1,.4487,1,1v16c0,1.6543,1.3457,3,3,3h4v1c0,1.1045.8955,2,2,2h4c1.1045,0,2-.8955,2-2v-4c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v1h-4c-.5515,0-1-.4487-1-1v-9h5v1c0,1.1045.8955,2,2,2ZM24,12h4v4h-4v-4ZM8,8h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ElementPicker.propTypes = iconPropTypes;
}
const Email = /*#__PURE__*/React.forwardRef(function Email({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Email.propTypes = iconPropTypes;
}
const EmailNew = /*#__PURE__*/React.forwardRef(function EmailNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "24",
    r: "4"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EmailNew.propTypes = iconPropTypes;
}
const EmissionsManagement = /*#__PURE__*/React.forwardRef(function EmissionsManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2h-2v26c0,1.1046.8954,2,2,2h11v-2H4V2ZM23,4v2h3.5859l-7.5859,7.5859-4.293-4.293c-.3905-.3905-1.0236-.3905-1.4141,0l-7.293,7.293,1.4141,1.4141,6.5859-6.5859,4.293,4.293c.3905.3904,1.0236.3904,1.4141,0l8.293-8.293v3.5859h2v-7s-7,0-7,0ZM22.48,20.863c-.682-.54-1.544-.863-2.48-.863h-3v3c0,2.206,1.794,4,4,4h1v3h2v-3h1c2.757,0,5-2.243,5-5v-4h-3c-1.933.0016-3.6925,1.116-4.52,2.863ZM22,25h-1c-1.103,0-2-.897-2-2v-1h1c1.103,0,2,.897,2,2v1ZM28,22c0,1.654-1.346,3-3,3h-1v-2c0-1.654,1.346-3,3-3h1v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EmissionsManagement.propTypes = iconPropTypes;
}
const Encryption = /*#__PURE__*/React.forwardRef(function Encryption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M29,21.2783V19a4,4,0,0,0-8,0v2.2783A1.9935,1.9935,0,0,0,20,23v5a2.0025,2.0025,0,0,0,2,2h6a2.0025,2.0025,0,0,0,2-2V23A1.9935,1.9935,0,0,0,29,21.2783ZM25,17a2.0025,2.0025,0,0,1,2,2v2H23V19A2.0025,2.0025,0,0,1,25,17ZM22,28V23h6v5Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V6H2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H16V6H14z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H20V6H18z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H4V16H2z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H4V26H2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H16V26H14z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H8V16H6z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V14H18z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26H8a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2h2a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,10,26ZM8,20v4h2V20Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h2a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,14,16Zm-2-6v4h2V10Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6H8A2.0023,2.0023,0,0,1,6,4V2H8V4h2V2h2V4A2.0023,2.0023,0,0,1,10,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Encryption.propTypes = iconPropTypes;
}
const EnergyRenewable = /*#__PURE__*/React.forwardRef(function EnergyRenewable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EnergyRenewable.propTypes = iconPropTypes;
}
const Enterprise = /*#__PURE__*/React.forwardRef(function Enterprise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H10V18H8z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H16V12H14z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V18H14z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V24H8z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V24H14z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Enterprise.propTypes = iconPropTypes;
}
const EnumerationDefinition = /*#__PURE__*/React.forwardRef(function EnumerationDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19.5328,16.0691c0-.9631.8772-1.4445,1.7885-1.4445,1.0486,0,1.4783.6532,1.4783,1.9257v5.4497h2.2004v-5.6732c0-2.2352-1.0315-3.5072-2.8712-3.5072-1.3922,0-2.1488.7395-2.5096,1.7021h-.0863v-1.4957h-2.2006v8.974h2.2006v-5.9309Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M14.908 19.9883L9.2693 19.9883 9.2693 16.9282 14.2548 16.9282 14.2548 14.917 9.2693 14.917 9.2693 12.0117 14.908 12.0117 14.908 10 7 10 7 22 14.908 22 14.908 19.9883z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EnumerationDefinition.propTypes = iconPropTypes;
}
const EnumerationUsage = /*#__PURE__*/React.forwardRef(function EnumerationUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19.5328,16.0691c0-.9631.8772-1.4445,1.7885-1.4445,1.0486,0,1.4783.6532,1.4783,1.9257v5.4497h2.2004v-5.6732c0-2.2352-1.0315-3.5072-2.8712-3.5072-1.3922,0-2.1488.7395-2.5096,1.7021h-.0863v-1.4957h-2.2006v8.974h2.2006v-5.9309Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M14.908 19.9883L9.2693 19.9883 9.2693 16.9282 14.2548 16.9282 14.2548 14.917 9.2693 14.917 9.2693 12.0117 14.908 12.0117 14.908 10 7 10 7 22 14.908 22 14.908 19.9883z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EnumerationUsage.propTypes = iconPropTypes;
}
const EqualApproximately = /*#__PURE__*/React.forwardRef(function EqualApproximately({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15c-1.7771,0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977,0-2.449.8629-3.2927,1.707l-1.4146-1.4141c1.0674-1.0675,2.5669-2.293,4.7073-2.293,1.7771,0,3.2314.8726,4.5144,1.6425,1.1636.6981,2.2627,1.3575,3.4856,1.3575,1.3975,0,2.4487-.8629,3.293-1.7072l1.4141,1.4143c-1.0674,1.0675-2.5671,2.2928-4.707,2.2928Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m20,22c-1.7771,0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977,0-2.449.8629-3.2927,1.707l-1.4146-1.4141c1.0674-1.0675,2.5669-2.293,4.7073-2.293,1.7771,0,3.2314.8726,4.5144,1.6425,1.1636.6981,2.2627,1.3575,3.4856,1.3575,1.3975,0,2.4487-.8629,3.293-1.7072l1.4141,1.4143c-1.0674,1.0675-2.5671,2.2928-4.707,2.2928Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-7.7197,0-14-6.2804-14-14S8.2802,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EqualApproximately.propTypes = iconPropTypes;
}
const Equalizer = /*#__PURE__*/React.forwardRef(function Equalizer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H10V30H2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24H10V26H2z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H20V30H12z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H20V26H12z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H10V22H2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H20V22H12z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H10V18H2z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H20V18H12z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V14H12z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H20V10H12z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H20V6H12z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H30V30H22z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H30V26H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Equalizer.propTypes = iconPropTypes;
}
const Erase = /*#__PURE__*/React.forwardRef(function Erase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H30V29H7z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,10.51,19.45,2.59a2,2,0,0,0-2.83,0l-14,14a2,2,0,0,0,0,2.83L7.13,24h9.59L27.38,13.34A2,2,0,0,0,27.38,10.51ZM15.89,22H8L4,18l6.31-6.31,7.93,7.92Zm3.76-3.76-7.92-7.93L18,4,26,11.93Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Erase.propTypes = iconPropTypes;
}
const WatsonHealthErase_3D = /*#__PURE__*/React.forwardRef(function WatsonHealthErase_3D({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4148,16.5132,22.488,8.5859a2.0014,2.0014,0,0,0-2.8291,0L5.6208,22.624a2.0024,2.0024,0,0,0,0,2.8291L10.1663,30h9.5908L30.4148,19.3413A2.001,2.001,0,0,0,30.4148,16.5132ZM18.929,28H10.9949l-3.96-3.9619,6.3123-6.3118,7.9276,7.9276Zm3.76-3.76-7.9276-7.9276L21.074,10l7.9267,7.9272Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M11,12H8V2h3a3.0033,3.0033,0,0,1,3,3V9A3.0033,3.0033,0,0,1,11,12Zm-1-2h1a1.0009,1.0009,0,0,0,1-1V5a1.0009,1.0009,0,0,0-1-1H10Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H0V4H4V6H1V8H4v2H0v2H4a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,4,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthErase_3D.propTypes = iconPropTypes;
}
const Error = /*#__PURE__*/React.forwardRef(function Error({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Error.propTypes = iconPropTypes;
}
const ErrorFilled = /*#__PURE__*/React.forwardRef(function ErrorFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"
    })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"
    })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
      d: "M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z"
    })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.9 7.2H17.1V24.799H14.9z",
    "data-icon-path": "inner-path",
    transform: "rotate(-45 16 16)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ErrorFilled.propTypes = iconPropTypes;
}
const ErrorOutline = /*#__PURE__*/React.forwardRef(function ErrorOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
      d: "M7.4 3.6H8.5V12.4H7.4z",
      transform: "rotate(-45.001 8 8)"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 7.2H17.1V24.799H14.9z",
    transform: "rotate(-45 16 16)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ErrorOutline.propTypes = iconPropTypes;
}
const Event = /*#__PURE__*/React.forwardRef(function Event({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Event.propTypes = iconPropTypes;
}
const EventChange = /*#__PURE__*/React.forwardRef(function EventChange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H19V22H17z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "25",
    r: "1.25"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m29,30H7c-.3499,0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L17.1143,7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11,21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823Zm-20.3474-2h18.6948l-9.3474-17.8448-9.3474,17.8448Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23H3c-.3467,0-.6685-.1794-.8506-.4742-.1824-.2948-.1987-.663-.0439-.973l2.5-5,1.7891.8945-1.7766,3.5527h2.3821v2Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M4.955 11.5H10.545V13.5H4.955z",
    transform: "rotate(-63.435 7.75 12.5)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "m10.8945,8.4473l-1.7891-.8945,2.5-5c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l2,4-1.7891.8945-1.1055-2.2112-1.6055,3.2112Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventChange.propTypes = iconPropTypes;
}
const EventIncident = /*#__PURE__*/React.forwardRef(function EventIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0176 26.7217L22.016 28.4541 24.9938 26.7322 24.9938 30 26.9907 30 26.9907 26.7316 30.0016 28.4727 31 26.7402 27.9898 24.9996 30.9902 23.2646 29.9918 21.5322 26.9907 23.2677 26.9907 20 24.9938 20 24.9938 23.2672 21.9984 21.5352 21 23.2676 23.9954 24.9996 21.0176 26.7217z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V21H15z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m18,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6.76,13-1.7744.9226-5.8728-11.2938L4.6472,28h13.3528v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventIncident.propTypes = iconPropTypes;
}
const EventSchedule = /*#__PURE__*/React.forwardRef(function EventSchedule({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventSchedule.propTypes = iconPropTypes;
}
const EventWarning = /*#__PURE__*/React.forwardRef(function EventWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3803,28h-6.7625l3.3822-6.7642,3.3803,6.7642Zm-3.3803-10c-.3915,0-.7305.2251-.8947.5527l-5,10c-.0674.1348-.1053.2866-.1053.4473,0,.5522.4477,1,1,1h10c.5523,0,1-.4478,1-1,0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V21H15z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6,11.5385-1.7744.9226-5.1128-9.8322L4.6472,28h10.3528v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventWarning.propTypes = iconPropTypes;
}
const Events = /*#__PURE__*/React.forwardRef(function Events({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24v2h2a3.0033,3.0033,0,0,1,3,3v4h2V19A5.0058,5.0058,0,0,0,26,14Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,24,2Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30H21V28a3.0033,3.0033,0,0,0-3-3H14a3.0033,3.0033,0,0,0-3,3v2H9V28a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,11Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8,14H6a5.0059,5.0059,0,0,0-5,5v4H3V19a3.0033,3.0033,0,0,1,3-3H8Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4A3,3,0,1,1,5,7,3,3,0,0,1,8,4M8,2a5,5,0,1,0,5,5A5,5,0,0,0,8,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Events.propTypes = iconPropTypes;
}
const EventsAlt = /*#__PURE__*/React.forwardRef(function EventsAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M18,31h2V29a1.0006,1.0006,0,0,1,1-1h6a1.0006,1.0006,0,0,1,1,1v2h2V29a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M24,25a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,24,25Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,24,19Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M2,31H4V29a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V29a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8,25a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,8,25Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,8,19Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M18,16h2V14a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V14a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,24,4Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16H4V14a1.0013,1.0013,0,0,1,1-1h6a1.0013,1.0013,0,0,1,1,1v2h2V14a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,8,10ZM8,4a2,2,0,1,0,2,2A2.002,2.002,0,0,0,8,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  EventsAlt.propTypes = iconPropTypes;
}
const ExamMode = /*#__PURE__*/React.forwardRef(function ExamMode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23v3H7V16.83l3.59,3.58L12,19,6,13,0,19l1.41,1.41L5,16.83V26a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V23Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M27,7v9.17l3.59-3.58L32,14l-6,6-6-6,1.41-1.41L25,16.17V7H13V5H25A2,2,0,0,1,27,7Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H4A2,2,0,0,1,2,8V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM4,4V8H8V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExamMode.propTypes = iconPropTypes;
}
const ExecutableProgram = /*#__PURE__*/React.forwardRef(function ExecutableProgram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25 21L32 26 25 31 25 21z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExecutableProgram.propTypes = iconPropTypes;
}
const Exit = /*#__PURE__*/React.forwardRef(function Exit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H28V28H26z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Exit.propTypes = iconPropTypes;
}
const ExpandAll = /*#__PURE__*/React.forwardRef(function ExpandAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExpandAll.propTypes = iconPropTypes;
}
const ExpandCategories = /*#__PURE__*/React.forwardRef(function ExpandCategories({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H26V28H20z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H28V20H20z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H30V12H20z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V28H15z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ExpandCategories.propTypes = iconPropTypes;
}
const Explore = /*#__PURE__*/React.forwardRef(function Explore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Explore.propTypes = iconPropTypes;
}
const Export = /*#__PURE__*/React.forwardRef(function Export({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
      d: "M13,12v2H3v-2H2v2l0,0c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1l0,0v-2H13z"
    })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
      d: "M3 6L3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24v4H6V24H4v4l.0076-.0049A1.9977,1.9977,0,0,0,6,30H26a2,2,0,0,0,2-2h0V24Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Export.propTypes = iconPropTypes;
}
const Eyedropper = /*#__PURE__*/React.forwardRef(function Eyedropper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H5V30H2z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M29.71,7.29l-5-5a1,1,0,0,0-1.41,0h0L20,5.59l-1.29-1.3L17.29,5.71,18.59,7,8.29,17.29A1,1,0,0,0,8,18v1.59l-2.71,2.7a1,1,0,0,0,0,1.41h0l3,3a1,1,0,0,0,1.41,0h0L12.41,24H14a1,1,0,0,0,.71-.29L25,13.41l1.29,1.3,1.42-1.42L26.41,12l3.3-3.29a1,1,0,0,0,0-1.41ZM13.59,22h-2L9,24.59,7.41,23,10,20.41v-2l10-10L23.59,12ZM25,10.59,21.41,7,24,4.41,27.59,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Eyedropper.propTypes = iconPropTypes;
}
const FaceActivated = /*#__PURE__*/React.forwardRef(function FaceActivated({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M9,20a8.13,8.13,0,0,0,14,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceActivated.propTypes = iconPropTypes;
}
const FaceActivatedAdd = /*#__PURE__*/React.forwardRef(function FaceActivatedAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M9,20a8.13,8.13,0,0,0,14,0Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceActivatedAdd.propTypes = iconPropTypes;
}
const FaceActivatedFilled = /*#__PURE__*/React.forwardRef(function FaceActivatedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceActivatedFilled.propTypes = iconPropTypes;
}
const FaceAdd = /*#__PURE__*/React.forwardRef(function FaceAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,0,1-5.14-2.92l-1.71,1a8,8,0,0,0,13.7,0l-1.71-1A6,6,0,0,1,16,22Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceAdd.propTypes = iconPropTypes;
}
const FaceCool = /*#__PURE__*/React.forwardRef(function FaceCool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceCool.propTypes = iconPropTypes;
}
const FaceDissatisfied = /*#__PURE__*/React.forwardRef(function FaceDissatisfied({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.5,2.5,0,0,0,11.5,11Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M16,19a8,8,0,0,0-6.85,3.89l1.71,1a6,6,0,0,1,10.28,0l1.71-1A8,8,0,0,0,16,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceDissatisfied.propTypes = iconPropTypes;
}
const FaceDissatisfiedFilled = /*#__PURE__*/React.forwardRef(function FaceDissatisfiedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceDissatisfiedFilled.propTypes = iconPropTypes;
}
const FaceDizzy = /*#__PURE__*/React.forwardRef(function FaceDizzy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M16,19a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceDizzy.propTypes = iconPropTypes;
}
const FaceDizzyFilled = /*#__PURE__*/React.forwardRef(function FaceDizzyFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceDizzyFilled.propTypes = iconPropTypes;
}
const FaceMask = /*#__PURE__*/React.forwardRef(function FaceMask({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.5,2.5,0,0,0,11.5,11Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceMask.propTypes = iconPropTypes;
}
const FaceNeutral = /*#__PURE__*/React.forwardRef(function FaceNeutral({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.5,2.5,0,0,0,11.5,11Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H22V22H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceNeutral.propTypes = iconPropTypes;
}
const FaceNeutralFilled = /*#__PURE__*/React.forwardRef(function FaceNeutralFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceNeutralFilled.propTypes = iconPropTypes;
}
const FacePending = /*#__PURE__*/React.forwardRef(function FacePending({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FacePending.propTypes = iconPropTypes;
}
const FacePendingFilled = /*#__PURE__*/React.forwardRef(function FacePendingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FacePendingFilled.propTypes = iconPropTypes;
}
const FaceSatisfied = /*#__PURE__*/React.forwardRef(function FaceSatisfied({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceSatisfied.propTypes = iconPropTypes;
}
const FaceSatisfiedFilled = /*#__PURE__*/React.forwardRef(function FaceSatisfiedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceSatisfiedFilled.propTypes = iconPropTypes;
}
const FaceWink = /*#__PURE__*/React.forwardRef(function FaceWink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.5,2.5,0,0,0,20.5,11Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H14V15H8z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceWink.propTypes = iconPropTypes;
}
const FaceWinkFilled = /*#__PURE__*/React.forwardRef(function FaceWinkFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FaceWinkFilled.propTypes = iconPropTypes;
}
const Factor = /*#__PURE__*/React.forwardRef(function Factor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Factor.propTypes = iconPropTypes;
}
const Fade = /*#__PURE__*/React.forwardRef(function Fade({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
      d: "M4.1,12.6l-0.6,0.8c0.6,0.5,1.3,0.9,2.1,1.2l0.3-0.9C5.3,13.4,4.7,13,4.1,12.6z"
    })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
      d: "M2.1,9l-1,0.2c0.1,0.8,0.4,1.6,0.8,2.3L2.8,11C2.4,10.4,2.2,9.7,2.1,9z"
    })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
      d: "M5.9,2.4L5.6,1.4C4.8,1.7,4.1,2.1,3.5,2.7l0.6,0.8C4.7,3,5.3,2.6,5.9,2.4z"
    })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
      d: "M2.8,5L1.9,4.5C1.5,5.2,1.3,6,1.1,6.8l1,0.2C2.2,6.3,2.5,5.6,2.8,5z"
    })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1v1c3.3,0,6,2.7,6,6s-2.7,6-6,6v1c3.9,0,7-3.1,7-7S11.9,1,8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24,25.14,7,26.67a13.79,13.79,0,0,0,4.18,2.44l.69-1.87A12,12,0,0,1,8.24,25.14Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19,18l-2,.41A14.09,14.09,0,0,0,3.86,23L5.59,22A12.44,12.44,0,0,1,4.19,18Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82,4.76l-.69-1.87A13.79,13.79,0,0,0,7,5.33L8.24,6.86A12,12,0,0,1,11.82,4.76Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59,10,3.86,9a14.37,14.37,0,0,0-1.64,4.59l2,.34A12.05,12.05,0,0,1,5.59,10Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2V4a12,12,0,0,1,0,24v2A14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fade.propTypes = iconPropTypes;
}
const Favorite = /*#__PURE__*/React.forwardRef(function Favorite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Favorite.propTypes = iconPropTypes;
}
const FavoriteFilled = /*#__PURE__*/React.forwardRef(function FavoriteFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29 l11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FavoriteFilled.propTypes = iconPropTypes;
}
const FavoriteHalf = /*#__PURE__*/React.forwardRef(function FavoriteHalf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FavoriteHalf.propTypes = iconPropTypes;
}
const FeatureMembership = /*#__PURE__*/React.forwardRef(function FeatureMembership({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,28v-9l8-8L13,2,4,11l8,8v9c0,1.1045.8955,2,2,2h14v-2h-14Zm-1-23.1716l6.1716,6.1716-6.1716,6.1716-6.1716-6.1716,6.1716-6.1716Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FeatureMembership.propTypes = iconPropTypes;
}
const FeatureMembershipFilled = /*#__PURE__*/React.forwardRef(function FeatureMembershipFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m14,28v-9l8-8L13,2,4,11l8,8v9c0,1.1045.8955,2,2,2h14v-2h-14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FeatureMembershipFilled.propTypes = iconPropTypes;
}
const FeaturePicker = /*#__PURE__*/React.forwardRef(function FeaturePicker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18h4c1.1045,0,2-.8955,2-2v-4c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v1h-5v-5c0-1.6543-1.3457-3-3-3h-4v-1c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v4c0,1.1045.8955,2,2,2h4c1.1045,0,2-.8955,2-2v-1h4c.5515,0,1,.4487,1,1v16c0,1.6543,1.3457,3,3,3h4v1c0,1.1045.8955,2,2,2h4c1.1045,0,2-.8955,2-2v-4c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v1h-4c-.5515,0-1-.4487-1-1v-9h5v1c0,1.1045.8955,2,2,2ZM24,12h4v4h-4v-4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FeaturePicker.propTypes = iconPropTypes;
}
const FeatureTyping = /*#__PURE__*/React.forwardRef(function FeatureTyping({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "22.5",
    r: "1.5",
    strokeWidth: "0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "6.5",
    cy: "22.5",
    r: "1.5",
    strokeWidth: "0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,28v-10h7c.3564,0,.686-.1899.8647-.498.0902-.1551.1353-.3285.1353-.502,0-.1711-.0441-.3424-.1318-.4961L12.8682,2.504c-.1919-.3359-.5301-.504-.8682-.504s-.6763.1681-.8682.504l-7.9999,13.9999c-.0878.1537-.1318.3249-.1318.4961,0,.1735.0451.3469.1353.502.1787.3081.5083.498.8647.498h7v10c0,1.1046.8954,2,2,2h15v-2h-15Zm-7.2769-12l6.2769-10.9844,6.2769,10.9844H5.7231Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FeatureTyping.propTypes = iconPropTypes;
}
const FetchUpload = /*#__PURE__*/React.forwardRef(function FetchUpload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FetchUpload.propTypes = iconPropTypes;
}
const FetchUploadCloud = /*#__PURE__*/React.forwardRef(function FetchUploadCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FetchUploadCloud.propTypes = iconPropTypes;
}
const FileStorage = /*#__PURE__*/React.forwardRef(function FileStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FileStorage.propTypes = iconPropTypes;
}
const Filter = /*#__PURE__*/React.forwardRef(function Filter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Filter.propTypes = iconPropTypes;
}
const FilterEdit = /*#__PURE__*/React.forwardRef(function FilterEdit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FilterEdit.propTypes = iconPropTypes;
}
const FilterRemove = /*#__PURE__*/React.forwardRef(function FilterRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FilterRemove.propTypes = iconPropTypes;
}
const FilterReset = /*#__PURE__*/React.forwardRef(function FilterReset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FilterReset.propTypes = iconPropTypes;
}
const Finance = /*#__PURE__*/React.forwardRef(function Finance({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11a1,1,0,0,0,1-1V7a1,1,0,0,0-.66-.94l-11-4a1,1,0,0,0-.68,0l-11,4A1,1,0,0,0,4,7v3a1,1,0,0,0,1,1H6V24H4v2H28V24H26V11ZM6,7.7,16,4.06,26,7.7V9H6ZM18,24H14V11h4ZM8,11h4V24H8ZM24,24H20V11h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Finance.propTypes = iconPropTypes;
}
const FinancialAssets = /*#__PURE__*/React.forwardRef(function FinancialAssets({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16h-2v2h-1c-1.1,0-2,.9-2,2v2c0,1.1.9,2,2,2h4v2h-6v2h3v2h2v-2h1c1.1,0,2-.9,2-2v-2c0-1.1-.9-2-2-2h-4v-2h6v-2h-3v-2ZM28,8h-6v-4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v4h-6c-1.1,0-2,.9-2,2v14c0,1.1.9,2,2,2h15v-2H4v-14h24v4h2v-4c0-1.1-.9-2-2-2ZM20,8h-8v-4h8v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FinancialAssets.propTypes = iconPropTypes;
}
const FingerprintRecognition = /*#__PURE__*/React.forwardRef(function FingerprintRecognition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FingerprintRecognition.propTypes = iconPropTypes;
}
const Fire = /*#__PURE__*/React.forwardRef(function Fire({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fire.propTypes = iconPropTypes;
}
const Firewall = /*#__PURE__*/React.forwardRef(function Firewall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20.3972v3c-1,0-2-1.5-2-4v-3c-4,5-5,7-5,9A5.0008,5.0008,0,0,0,23.0458,30,7.5281,7.5281,0,0,1,25,26.3972,7.5281,7.5281,0,0,1,26.9542,30,5.0008,5.0008,0,0,0,30,25.3972C30,23.3972,28.875,21.8258,27,20.3972Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28H4V24H17V22H4a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H17Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H17V18H7V14H28l.0011,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10H4A2.0021,2.0021,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H25a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,25,10ZM4,4V8H25V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Firewall.propTypes = iconPropTypes;
}
const FirewallClassic = /*#__PURE__*/React.forwardRef(function FirewallClassic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20V17a4,4,0,0,0-8,0v3a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V22A2.0023,2.0023,0,0,0,28,20Zm-6-3a2,2,0,0,1,4,0v3H22Zm6,11H20V22h8Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M15,27H4a2,2,0,0,1-2-2V22a2,2,0,0,1,2-2H15v2H4v3H15Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M17,18H8a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2H19v2H8v3h9Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9H4A2,2,0,0,1,2,7V4A2,2,0,0,1,4,2H22a2,2,0,0,1,2,2V7A2,2,0,0,1,22,9ZM4,7H22V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FirewallClassic.propTypes = iconPropTypes;
}
const Fish = /*#__PURE__*/React.forwardRef(function Fish({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "7",
    r: "1"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fish.propTypes = iconPropTypes;
}
const FishMultiple = /*#__PURE__*/React.forwardRef(function FishMultiple({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "11",
    r: "1"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "11",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "11",
    r: "1"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FishMultiple.propTypes = iconPropTypes;
}
const FitToHeight = /*#__PURE__*/React.forwardRef(function FitToHeight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FitToHeight.propTypes = iconPropTypes;
}
const FitToScreen = /*#__PURE__*/React.forwardRef(function FitToScreen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L24 16 24 8 16 8 16 10 22 10 22 16z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FitToScreen.propTypes = iconPropTypes;
}
const FitToWidth = /*#__PURE__*/React.forwardRef(function FitToWidth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FitToWidth.propTypes = iconPropTypes;
}
const Flag = /*#__PURE__*/React.forwardRef(function Flag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Flag.propTypes = iconPropTypes;
}
const FlagFilled = /*#__PURE__*/React.forwardRef(function FlagFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H4V2H28l-5.8,9L28,20H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlagFilled.propTypes = iconPropTypes;
}
const FlaggingTaxi = /*#__PURE__*/React.forwardRef(function FlaggingTaxi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlaggingTaxi.propTypes = iconPropTypes;
}
const Flash = /*#__PURE__*/React.forwardRef(function Flash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Flash.propTypes = iconPropTypes;
}

export { DoubleInteger, DownToBottom, Download, Downstream, DragHorizontal, DragVertical, Draggable, Draw, DrillBack, DrillDown, DrillThrough, Drink_01, Drink_02, DriverAnalysis, Drone, DroneDelivery, DroneFront, DroneVideo, DropPhoto, DropPhotoFilled, Drought, Dvr, Earth, EarthAmericas, EarthAmericasFilled, EarthEuropeAfrica, EarthEuropeAfricaFilled, EarthFilled, EarthSoutheastAsia, EarthSoutheastAsiaFilled, Earthquake, EdgeCluster, EdgeDevice, EdgeNode, EdgeNodeAlt, EdgeService, Edit, EditOff, EdtLoop, Education, ElementPicker, Email, EmailNew, EmissionsManagement, Encryption, EnergyRenewable, Enterprise, EnumerationDefinition, EnumerationUsage, EqualApproximately, Equalizer, Erase, Error, ErrorFilled, ErrorOutline, Event, EventChange, EventIncident, EventSchedule, EventWarning, Events, EventsAlt, ExamMode, ExecutableProgram, Exit, ExpandAll, ExpandCategories, Explore, Export, Eyedropper, FaceActivated, FaceActivatedAdd, FaceActivatedFilled, FaceAdd, FaceCool, FaceDissatisfied, FaceDissatisfiedFilled, FaceDizzy, FaceDizzyFilled, FaceMask, FaceNeutral, FaceNeutralFilled, FacePending, FacePendingFilled, FaceSatisfied, FaceSatisfiedFilled, FaceWink, FaceWinkFilled, Factor, Fade, Favorite, FavoriteFilled, FavoriteHalf, FeatureMembership, FeatureMembershipFilled, FeaturePicker, FeatureTyping, FetchUpload, FetchUploadCloud, FileStorage, Filter, FilterEdit, FilterRemove, FilterReset, Finance, FinancialAssets, FingerprintRecognition, Fire, Firewall, FirewallClassic, Fish, FishMultiple, FitToHeight, FitToScreen, FitToWidth, Flag, FlagFilled, FlaggingTaxi, Flash, WatsonHealthDownloadStudy, WatsonHealthEdgeEnhancement, WatsonHealthEdgeEnhancement_01, WatsonHealthEdgeEnhancement_02, WatsonHealthEdgeEnhancement_03, WatsonHealthErase_3D };
